export default angular.module('gm.wealth.common')
.directive('gmwNumberInt', gmwNumberInt)
.name;

function gmwNumberInt() {
  'ngInject';

  const directive = {
    link,
    require: 'ngModel',
    restrict: 'A',
  };
  return directive;

  function link(_scope, _element, _attrs, ctrl) {
    function validate(text) {
      const str = text ? text.toString() : '';

      if ((/[^\d]/).test(str)) {
        const cleaned = str.replace(/[^\d]/ig, '');

        const number = parseInt(cleaned, 10);

        ctrl.$setViewValue(number);
        ctrl.$render();

        return number;
      }

      return parseInt(text, 10);
    }

    ctrl.$parsers.unshift(validate);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/number-int/number-int.js